module.exports = __webpack_public_path__ + "img/无经验值记录.5ba76e07.png";